// components/common/PincodeLookup.tsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input } from "../../ui";
import { toast } from "react-toastify";

interface PincodeLookupProps {
  label?: string;
  value?: {
    pincode?: string | number;
    state?: string;
    district?: string;
    village?: string;
  };
  onChange: (data: {
    pincode: string | number;
    state: string;
    district: string;
    village: string;
  }) => void;
}

const AddressFields: React.FC<PincodeLookupProps> = ({
  label,
  value,
  onChange,
}) => {
  const [pincode, setPincode] = useState(value?.pincode || "");
  const [state, setState] = useState(value?.state || "");
  const [district, setDistrict] = useState(value?.district || "");
  const [village, setVillage] = useState(value?.village || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handlePincodeChange = async (val: string) => {
    setPincode(val);
    setError("");
    if (val.length === 6) {
      setLoading(true);
      try {
        // You can replace with your own API endpoint if you have one
        const res = await axios.get(
          `https://api.postalpincode.in/pincode/${val}`
        );
        const data = res.data?.[0];
        if (data.Status === "Success" && data.PostOffice?.length) {
          const office = data.PostOffice[0];
          setState(office.State);
          setDistrict(office.District);
          setVillage(office.Name);

          onChange({
            pincode: val,
            state: office.State,
            district: office.District,
            village: office.Name,
          });
        } else {
          toast.error("Please enter valid Pincode");
          setError("Invalid Pincode");
          setState("");
          setDistrict("");
          setVillage("");
          onChange({
            pincode: val,
            state: "",
            district: "",
            village: "",
          });
        }
      } catch (err) {
        setError("Error fetching location details");
      } finally {
        setLoading(false);
      }
    } else {
      onChange({
        pincode: val,
        state: state,
        district: district,
        village: village,
      });
    }
  };

  useEffect(() => {
    onChange({ pincode, state, district, village });
  }, [state, district, village]);

  return (
    <div className="">
      <div className="flex gap-4">
        <Input
          label="Pincode "
          type="text"
          required={false}
          value={pincode}
          className="flex-1"
          onChange={(e) => handlePincodeChange(e.target.value)}
        />
        {/* 
          {loading && (
            <p className="text-xs text-blue-500">Fetching details...</p>
          )}
          {error && <p className="text-xs text-red-500">{error}</p>} */}

        <Input
          label="State "
          type="text"
          required={false}
          value={state}
          className="flex-1"
          onChange={(e) => setState(e.target.value)}
        />
      </div>
      <div className="flex gap-4 space_18">
        <Input
          label="District "
          type="text"
          required={false}
          value={district}
          className="flex-1"
          onChange={(e) => setDistrict(e.target.value)}
        />
        <Input
          label="Village / Street "
          type="text"
          required={false}
          value={village}
          className="flex-1"
          onChange={(e) => setVillage(e.target.value)}
        />
      </div>
    </div>
  );
};

export default AddressFields;
